import React from "react";
import { Filter } from "react-admin";

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { ExternalTerminalConnectionStatus } from "entities/ExternalTerminalConnectionStatus";


export const ExternalTerminalLinkFilter = (props) => (
	<Filter {...props}>
		<TextInputEx source="external_owner_username" />
		<TextInputEx source="external_name" />
		<SelectEnumInput 
			source="status" 
			enumName="external_terminal_status" 
			enumObj={ExternalTerminalConnectionStatus} 
		/>
	</Filter>
);
